import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.local';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EmargementUserResponse, EmargementUsersResponse} from '../../models/emargementUsers/EmargementUsers';
import {EmargementUserBody} from '../../models/emargementUsers/EmargementUserBody';
import {Params} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EmargementsUsersService {

  private apiUrl = `${environment.apiUrl}/emargements-users`;
  // behaviorSubject = new BehaviorSubject<EmargementUsersResponse | null>(null);

  constructor(private http: HttpClient) { }

  getEmargementUsers(params?: Params): Observable<EmargementUsersResponse> {
    return this.http.get<EmargementUsersResponse>(this.apiUrl, {params});
  }

  getEmargementUserById(id: number): Observable<EmargementUserResponse> {
    return this.http.get<EmargementUserResponse>(`${this.apiUrl}/${id}`);
  }

  postEmargementUser(emargementUserBody: EmargementUserBody): Observable<EmargementUserResponse> {
    return this.http.post<EmargementUserResponse>(this.apiUrl, emargementUserBody);
  }

  updateEmargementUser(id: number, emargementUserBody: EmargementUserBody): Observable<EmargementUserResponse> {
    return this.http.put<EmargementUserResponse>(`${this.apiUrl}/${id}`, emargementUserBody);
  }

  deleteEmargementUser(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
